module.exports = __webpack_public_path__ + "static/media/no-result.2d6990fd.svg";